module.exports = __webpack_public_path__ + "img/share.a42ad7c6.png";